import {ApiClient} from '@hconnect/apiclient'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import type {UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {
  CommentKpiValue,
  ExpertSystemEquipmentType,
  NewCommentKpi,
  YearMonth,
  MtmKpiValueQueryKey,
  CommentsQueryKey,
  DailyKpiValuesQueryKey
} from '../types'

export const useCommentKpiCreate = (
  kpiTargetEquipmentType: ExpertSystemEquipmentType,
  hierarchyId: string,
  yearMonth: YearMonth,
  options?: UseMutationOptions<CommentKpiValue, AxiosError<{message?: string}>, NewCommentKpi>
) => {
  const queryClient = useQueryClient()

  return useMutation<CommentKpiValue, AxiosError<{message?: string}>, NewCommentKpi>({
    mutationFn: async (newCommentData) => {
      const path = `/expert-system/kpis/${kpiTargetEquipmentType}/mtm/${yearMonth}/${hierarchyId}/comments`
      const response = await ApiClient.axiosInstance.post<CommentKpiValue>(path, newCommentData)
      return response.data
    },
    ...options,
    onSuccess: async (data, variables, context, mutation) => {
      await queryClient.invalidateQueries({queryKey: [CommentsQueryKey]})
      await queryClient.invalidateQueries({queryKey: [MtmKpiValueQueryKey]})
      await queryClient.invalidateQueries({queryKey: [DailyKpiValuesQueryKey]})
      await options?.onSuccess?.(data, variables, context, mutation)
    }
  })
}
